var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M3.342 3.342a1.167 1.167 0 0 1 1.65 0L10 8.35l5.008-5.008a1.167 1.167 0 1 1 1.65 1.65L11.65 10l5.008 5.008a1.167 1.167 0 0 1-1.65 1.65L10 11.65l-5.008 5.008a1.167 1.167 0 0 1-1.65-1.65L8.35 10 3.342 4.992a1.167 1.167 0 0 1 0-1.65",
    clipRule: "evenodd"
  })));
};
export default SvgX;